<template>
  <div id="app" class="global-wrapper" v-bind:class="{'services-page': $root.isService}">
    <!-- panel -->
    <Panel v-if="$root.isAdmin()" />
    <!-- END panel -->

    <!-- Header -->
    <Header />
    <!-- End Header -->

    <!-- Content -->
    <router-view></router-view>
    <!-- End Content -->

    <!-- Footer -->
    <Footer />
    <!-- End Footer -->
  </div>
</template>

<script>
import Panel from './components/Panel.vue'  
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',

  components: {
    Panel,
    Header,
    Footer
  }
}
</script>
